export const isWebsiteLead = lead =>
  lead?.leadSource === 'wordpress' || lead?.integration?.provider === 'wordpress';

export const getLeadSourceName = lead => {
  if (isWebsiteLead(lead)) return 'Website';
  return {
    meta: 'Meta',
    landing: 'Landing page',
    manual: 'Manual',
    import: 'Imported',
  }[lead?.leadSource] || 'Other';
};
